import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/components/breadcrumb.tsx");
;
import(/* webpackMode: "eager" */ "/home/bdeh8989/nodevenv/dev.ecole-st-augustin.fr/v2/app/20/lib/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/bdeh8989/nodevenv/dev.ecole-st-augustin.fr/v2/app/20/lib/node_modules/next/dist/client/link.js");
